import React from "react";
import { revoSizeToPadding, } from "../components/util/layoutconstants";
import { getThemeColorVar } from "../helper/color";
import { css, cx } from "emotion";
import { revoSpecToCss } from "../helper/responsive";
import classNames from "classnames";
const gridClass = css({
    display: "grid",
});
const spacingMap = {
    sm: "2.5px",
    base: "5px",
    md: "10px",
    lg: "15px",
    xl: "20px",
    xxl: "25px",
};
function isBetterGridProps(props) {
    return (props.padding !== undefined ||
        typeof props.gap === "object" ||
        typeof props.colGap === "object" ||
        typeof props.rowGap === "object" ||
        typeof props.gap === "number" ||
        typeof props.colGap === "number" ||
        typeof props.rowGap === "number");
}
export const Grid = (props) => {
    const { backgroundColor } = props;
    const classes = [
        gridClass,
        css(Object.assign({ zIndex: props.zIndex }, (props.enablePointerEventPassthrough
            ? {
                pointerEvents: "none",
                "> *": {
                    pointerEvents: "initial",
                },
            }
            : {}))),
    ];
    props.className && classes.push(props.className);
    if (!isBetterGridProps(props)) {
        const colGap = props.colGap || props.gap;
        if (colGap) {
            classes.push(css({
                gridColumnGap: spacingMap[colGap],
            }));
        }
        const rowGap = props.rowGap || props.gap;
        if (rowGap) {
            classes.push(css({
                gridRowGap: spacingMap[rowGap],
            }));
        }
        if (props.paddingX) {
            classes.push(css({
                paddingLeft: spacingMap[props.paddingX],
                paddingRight: spacingMap[props.paddingX],
            }));
        }
        if (props.paddingY) {
            classes.push(css({
                paddingTop: spacingMap[props.paddingY],
                paddingBottom: spacingMap[props.paddingY],
            }));
        }
    }
    else {
        const { gap, rowGap, colGap } = props;
        const emotionStyles = [];
        if (props.padding) {
            const { padding } = props;
            emotionStyles.push(revoSpecToCss(padding, revoSizeToPadding));
        }
        if (gap !== undefined)
            emotionStyles.push(revoSpecToCss(gap, (i) => ({ gridGap: `${i}px` })));
        if (rowGap !== undefined)
            emotionStyles.push(revoSpecToCss(rowGap, (i) => ({ gridRowGap: `${i}px` })));
        if (colGap !== undefined)
            emotionStyles.push(revoSpecToCss(colGap, (i) => ({ gridColumnGap: `${i}px` })));
        classes.push(css(emotionStyles));
    }
    const templateColumns = props.columnSpec
        ? typeof props.columnSpec === "string"
            ? props.columnSpec
            : props.columnSpec.map((elem) => elem.join("")).join(" ")
        : `repeat(${props.columns || 12}, 1fr)`;
    classes.push(css({
        gridTemplateColumns: templateColumns,
    }));
    if (backgroundColor) {
        classes.push(css({
            backgroundColor: getThemeColorVar(backgroundColor.color, backgroundColor.colorType),
        }));
    }
    if (props.gridAutoRows) {
        classes.push(css({
            gridAutoRows: props.gridAutoRows,
        }));
    }
    else if (props.minRowHeight) {
        classes.push(css({
            gridAutoRows: `minmax(${props.minRowHeight.join("")}, auto)`,
        }));
    }
    if (props.rowSpec) {
        classes.push(css({
            gridTemplateRows: typeof props.rowSpec === "string"
                ? props.rowSpec
                : props.rowSpec.map((elem) => elem.join("")).join(" "),
        }));
    }
    if (props.height) {
        classes.push(css({
            height: props.height.join(""),
        }));
    }
    return (React.createElement("div", { className: classNames("revo-grid", cx(classes)) }, props.children));
};
export default Grid;
//# sourceMappingURL=grid.js.map